exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".help-book-demo-page.personal-account-page{min-height:0;padding:0;border:0;border-radius:15px;overflow:hidden}.help-book-demo-widget{width:100%;min-width:320px;height:calc(100vh - 170px);min-height:560px}@media (max-width:767px){.help-book-demo-widget{height:calc(100vh - 150px);min-height:520px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./Client/app/views/account.management/help/help.book-demo.component.css
// module id = 1163
// module chunks = 0